// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTicketAlt, FaGift, FaTrophy, FaHome, FaSignOutAlt, FaWallet, FaUser, FaUserAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { name: "Home", icon: FaHome, link: "/home" },
    { name: "Prizes", icon: FaGift, link: "/prizes" },
    { name: "Campaigns", icon: FaTicketAlt, link: "/campaigns" },
    // { name: "Wallet", icon: FaWallet, link: "/wallet" },
  ];

  useEffect(() => {
    setIsLoggedIn(sessionStorage.getItem("isLoggedIn") === "true");
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const logout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <>
      {/* NAVBAR */}
      <motion.nav
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        className={`fixed w-full z-50 ${scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-yellow-300 shadow-lg"
          : "bg-transparent" //bg-yellow-500/10 border border-yellow-400/40 text-yellow-400
          }`}
      >
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center h-16">

          {/* LOGO */}
          <img
            src="/logo.png"
            alt="logo"
            className="h-10 cursor-pointer"
            onClick={() => navigate("/home")}
          />

          {/* DESKTOP MENU */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.name}
                  onClick={() => navigate(item.link)}
                  className="flex items-center gap-2 text-yellow-600 font-medium hover:text-yellow-900 transition"
                >
                  <Icon className="text-yellow-600" />
                  {item.name}
                </button>
              );
            })}

            {isLoggedIn ? (
              <>
                <button onClick={() => navigate("/myaccount")}
                  className="text-yellow-600 flex items-center font-medium"><FaUserAlt className="text-yellow-600 me-2" />My Account</button>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-5 py-1 rounded-full font-semibold
                      bg-gradient-to-r from-red-400 to-red-500 text-white
                      shadow-lg hover:scale-105 hover:shadow-xl transition"
                >
                  <FaSignOutAlt className="text-white" />
                  Logout
                </button>
              </>
            ) : (
              <button onClick={() => navigate("/")} className="goldBtn">
                Login
              </button>
            )}
          </div>

          {/* PREMIUM HAMBURGER */}
          <button onClick={() => setIsOpen(true)} className="md:hidden">
            <div className="space-y-1">
              <span className="block w-7 h-[3px] bg-yellow-700 rounded"></span>
              <span className="block w-7 h-[3px] bg-yellow-700 rounded"></span>
              <span className="block w-7 h-[3px] bg-yellow-700 rounded"></span>
            </div>
          </button>
        </div>
      </motion.nav>


      {/* FULLSCREEN MOBILE MENU */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 bg-white/95 backdrop-blur-2xl z-50 flex flex-col"
          >

            {/* SIDEBAR HEADER */}
            <div className="flex justify-between items-center px-6 py-5 border-b border-yellow-200">

              {/* LOGO */}
              <img
                src="/logo.png"
                alt="logo"
                className="h-10 object-contain"
                onClick={() => {
                  navigate("/home");
                  setIsOpen(false);
                }}
              />

              {/* CLOSE BUTTON */}
              <button
                onClick={() => setIsOpen(false)}
                className="text-3xl text-yellow-700 font-light"
              >
                ✕
              </button>
            </div>

            {/* MENU ITEMS */}
            <div className="flex-1 flex flex-col justify-start py-4 gap-8 px-8 text-2xl font-semibold text-yellow-700">

              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.name}
                    onClick={() => navigate(item.link)}
                    className="flex items-center gap-2 text-yellow-700 font-medium hover:text-yellow-900 transition"
                  >
                    <Icon className="text-yellow-600 me-2" />
                    {item.name}
                  </button>
                );
              })}
              {isLoggedIn ? (
                <>
                  <button
                    onClick={() => {
                      navigate("/myaccount");
                      setIsOpen(false);
                    }}
                    className="text-left text-yellow-600 flex items-center"
                  >
                    <FaUserAlt className="text-yellow-600 me-2" />
                    My Account
                  </button>

                  <button
                    onClick={() => {
                      logout();
                      setIsOpen(false);
                    }}
                    className="flex items-center text-left text-red-500"
                  >
                    <FaSignOutAlt className="text-red-500 me-2" />
                    Logout
                  </button>
                </>
              ) : (
                <button
                  onClick={() => {
                    navigate("/");
                    setIsOpen(false);
                  }}
                  className="text-left"
                >
                  Login
                </button>
              )}
            </div>

          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;